module.exports = __webpack_public_path__ + "static/media/pencil-purple.9d20ceb7.svg";